(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';
  const __productId = document.currentScript?.dataset.productId || '';

  const sectionRoot = document.getElementById(("YurchakProductUI-" + __shopifySectionId + ""));
  if (!sectionRoot || sectionRoot.dataset.yurchakInitialized === 'true') return;
  sectionRoot.dataset.yurchakInitialized = 'true';

  const videoMediaId = ("yurchak-video-" + __productId + "");

  const syncProductThemeVars = () => {
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    const source = getComputedStyle(sectionRoot);
    const names = ['--yp-media-radius', '--yp-button-radius', '--yp-title-size', '--yp-accent'];
    names.forEach((name) => {
      const value = source.getPropertyValue(name).trim();
      if (value) info.style.setProperty(name, value);
    });
    info.style.setProperty('--yp-thumb-radius', '4px');
    if (!info.style.getPropertyValue('--yp-accent')) info.style.setProperty('--yp-accent', '#05070d');
  };

  const injectVideo = () => {
    const gallery = document.querySelector('product-info[id^="MainProduct-"] media-gallery');
    const slideTemplate = sectionRoot.querySelector('template[data-yurchak-product-video-slide]');
    if (!gallery || !slideTemplate) return;

    const viewerList = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!viewerList) return;

    if (!viewerList.querySelector(`[data-media-id="${videoMediaId}"]`)) {
      viewerList.appendChild(slideTemplate.content.firstElementChild.cloneNode(true));
      gallery.elements?.viewer?.resetPages?.();
    }

    const thumbTemplate = sectionRoot.querySelector('template[data-yurchak-product-video-thumb]');
    const thumbList = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (thumbTemplate && thumbList && !thumbList.querySelector(`[data-target="${videoMediaId}"]`)) {
      const thumb = thumbTemplate.content.firstElementChild.cloneNode(true);
      thumb.dataset.mediaPosition = String(viewerList.querySelectorAll('[data-media-id]').length);
      thumb.querySelector('button')?.addEventListener('click', () => gallery.setActiveMedia?.(videoMediaId, false));
      thumbList.appendChild(thumb);
    }

    const total = viewerList.querySelectorAll('[data-media-id]').length;
    gallery.querySelectorAll('.slider-counter--total').forEach((node) => { node.textContent = total; });
  };

  const enhanceBuyButtons = () => {
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;

    const form = info.querySelector('product-form form[data-type="add-to-cart-form"]');
    const addButton = info.querySelector('.product-form__submit');
    const buttons = info.querySelector('.product-form__buttons');
    const nativePayment = buttons?.querySelector('.shopify-payment-button');
    if (!form || !addButton || !buttons) return;

    const text = addButton.querySelector('span');
    if (text && !addButton.disabled && addButton.getAttribute('aria-disabled') !== 'true') text.textContent = 'ADD TO BAG';

    let buyNow = buttons.querySelector('[data-yurchak-buy-now]');
    if (nativePayment && !buyNow) {
      buyNow = document.createElement('button');
      buyNow.type = 'button';
      buyNow.className = 'button yurchak-buy-now';
      buyNow.dataset.yurchakBuyNow = '';
      buyNow.textContent = 'BUY NOW';
      buttons.appendChild(buyNow);

      buyNow.addEventListener('click', () => {
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = info.querySelector('.quantity__input');
        const variantId = Number(variantInput?.value || 0);
        const quantity = Math.max(1, Number(quantityInput?.value || 1));
        if (!variantId || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;
        const root = window.Shopify?.routes?.root || (window.Shopify?.routes?.root || '/');
        window.location.assign(`${root}cart/${variantId}:${quantity}?checkout`);
      });
    }

    if (buyNow) buyNow.disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
  };

  const boot = () => {
    syncProductThemeVars();
    injectVideo();
    enhanceBuyButtons();
    window.setTimeout(enhanceBuyButtons, 350);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => {
        syncProductThemeVars();
        injectVideo();
        enhanceBuyButtons();
      });
    });
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(() => {
      syncProductThemeVars();
      injectVideo();
      enhanceBuyButtons();
    });
  });
})();
